"use client";

import CountUp from "react-countup";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { stats } from "@/lib/data";
import Reveal from "@/components/ui/Reveal";

export default function Stats() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.4 });

  return (
    <section className="bg-ink py-20 lg:py-24" ref={ref}>
      <div className="container-px mx-auto max-w-7xl">
        <div className="grid grid-cols-2 gap-8 lg:grid-cols-4">
          {stats.map((stat, i) => (
            <Reveal key={stat.label} delay={i * 0.08} direction="scale">
              <div className="text-center">
                <p className="text-4xl font-bold tracking-tight text-white sm:text-5xl">
                  {inView ? (
                    <CountUp
                      end={stat.value}
                      duration={2.2}
                      decimals={stat.decimals || 0}
                      suffix={stat.suffix}
                    />
                  ) : (
                    "0"
                  )}
                </p>
                <p className="mt-2 text-sm text-white/60">{stat.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
